// Distintivos de papel e de estado de conta (usados na lista e na ficha).
import { PLAYER_ROLE, type AccountStatus } from "@ecliptica/contexts-accounts";
import { useTranslation } from "@ecliptica/i18n";
import { Badge } from "@ecliptica/ui";
import { useRoleLabel } from "../roles/useRoles";

const STATUS_VARIANT = { active: "success", suspended: "warning", banned: "destructive", unverified: "secondary" } as const;

export function StatusBadge({ status }: { status: AccountStatus }) {
  const { t } = useTranslation();
  return <Badge variant={STATUS_VARIANT[status]}>{t(`users.status.${status}`)}</Badge>;
}

/** Papel com o nome vindo da BD (backoffice → Papéis). */
export function RoleBadge({ role }: { role: string }) {
  const label = useRoleLabel();
  return <Badge variant={role === PLAYER_ROLE ? "outline" : "default"}>{label(role)}</Badge>;
}
